import React from 'react'
import { ListSubheader } from '@material-ui/core'
import { getLang } from '../../app/selectors/lang'
import { SedaTimeseries } from '../../timeseries'
import { useAppContext } from '../../app/hooks'
import { TIMESERIES_X_EXTENTS } from '../../timeseries/constants'

const SedaLocationTimeseries = ({ location }) => {
  const {
    // metric,
    demographic,
  } = useAppContext()
  const [start, end] = TIMESERIES_X_EXTENTS
  const group = getLang(`LABEL_STUDENTS_${demographic}`)
  const title = getLang(`LOCATION_SUBHEADING_TIMESERIES_avg`, { start, end, group })
  return (
    <>
      <ListSubheader>
        <div>
          {title}
        </div>
      </ListSubheader>
      <SedaTimeseries
        locationData={location}
      />
    </>
  )
}

SedaLocationTimeseries.propTypes = {

}

export default SedaLocationTimeseries
